/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */
import React from 'react';

import { jsx } from '@atlaskit/css';
import type { ConversationAction } from '@atlassian/rovo-conversation-actions/types';

// Lazy load to avoid loading useRovoActionTrigger when action shortcuts are not needed
const LazyAIActionShortcut = React.lazy(() =>
	import(/* webpackChunkName: "@atlaskit-internal_ai-action-shortcut" */ './main').then(
		(module) => ({
			default: module.AIActionShortcut,
		}),
	),
);

type AIActionShortcutProps = {
	action: ConversationAction;
};

export const AIActionShortcut = ({ action }: AIActionShortcutProps): JSX.Element => {
	return <LazyAIActionShortcut action={action} />;
};
